import { convertAdInfo } from './utils';
import { AdsManager, AdsManagerEventKey, } from '../ads-manager';
export class ImaAdsManagerAdapter extends AdsManager {
    constructor(adsManager, adType) {
        super();
        this.bind(adsManager, adType);
    }
    bind(adsManager, adType) {
        adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, () => {
            this.dispatch(AdsManagerEventKey.ALL_ADS_COMPLETED, {});
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.COMPLETE, {
                adInfo,
                adType,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.AD_METADATA, () => {
            const cuePoints = adsManager.getCuePoints() ?? [];
            const metaDataCuePoints = cuePoints.map((cuePoint) => ({
                start: cuePoint,
            }));
            this.dispatch(AdsManagerEventKey.AD_METADATA, {
                adType,
                cuePoints: metaDataCuePoints,
            });
        });
        /**
         * TIP: Could be fired pretty randomly before or after CONTENT_PAUSE_REQUESTED event
         * so better rely on this event
         */
        adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.LOADED, {
                adType,
                adInfo,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, () => {
            this.dispatch(AdsManagerEventKey.CONTENT_PAUSE_REQUESTED, {});
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, () => {
            this.dispatch(AdsManagerEventKey.CONTENT_RESUME_REQUESTED, {});
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.PAUSED, {
                adType,
                adInfo,
                position: adInfo.duration - adsManager.getRemainingTime(),
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.RESUMED, {
                adType,
                adInfo,
                position: adInfo.duration - adsManager.getRemainingTime(),
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.STARTED, {
                adType,
                adInfo,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, (e) => {
            const adData = e.getAdData();
            this.dispatch(AdsManagerEventKey.AD_PROGRESS, {
                adType,
                position: adData.currentTime,
                duration: adData.duration,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.CLICK, () => {
            // pause advertisement when user opened advertiser url
            adsManager?.pause();
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            const position = adInfo.duration - Math.max(0, adsManager.getRemainingTime());
            this.dispatch(AdsManagerEventKey.SKIPPED, {
                adType,
                adInfo,
                position,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.FIRST_QUARTILE, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.FIRST_QUARTILE, {
                adType,
                adInfo,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.MIDPOINT, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.MIDPOINT, {
                adType,
                adInfo,
            });
        });
        adsManager.addEventListener(google.ima.AdEvent.Type.THIRD_QUARTILE, (e) => {
            const adInfo = convertAdInfo(e);
            if (!adInfo) {
                return;
            }
            this.dispatch(AdsManagerEventKey.THIRD_QUARTILE, {
                adType,
                adInfo,
            });
        });
    }
}
